import { H3 } from '@h3/types';
// 日程字段设置
const scheduleMappings = require('!!raw-loader!./local-plugins/schedule/ui/properties/ScheduleMappings.vue');
// 日程设计态
const scheduleDesign = require('!!raw-loader!./local-plugins/schedule/ui/design.vue');
// 日程运行态
const scheduleRuntime = require('!!raw-loader!./local-plugins/schedule/ui/runtime2.vue');
// 场景群聊运行时
const sceneGroupRuntime = require('!!raw-loader!./local-plugins/scene-group/runtime.vue');
// 场景群聊字段设置
const sceneGroupMappings = require('!!raw-loader!./local-plugins/scene-group/SceneGroupMappings.vue');
// 场景群聊快捷入口配置
const SceneGroupSetting = require('!!raw-loader!./local-plugins/scene-group/SceneGroupSetting.vue');

export const localPlugins: H3.Plugin.Next.IPluginInstance[] = [
    {
        auth: [],
        author: '',
        code: 'schedule',
        description: '',
        engineCode: '',
        extension: [],
        helpLinkUrl: '',
        hook: '',
        icon: 'calendar-view-stroke',
        name: '日程',
        publishedTime: '',
        id: '',
        version: '0.0.1',
        status: 1,
        ui: [
            {
                createSchema: true,
                dataType: H3.Control.BizDataType.String,
                definition: '',
                design: {
                    code: scheduleDesign.default,
                    isDefault: true,
                    properties: [
                        {
                            key: 'ScheduleMappings',
                            name: '字段配置',
                            code: scheduleMappings.default,
                            required: false,
                            type: 31,
                        },
                    ],
                },
                runtime: {
                    pcCode: scheduleRuntime.default,
                    pcViewCode: '',
                    mobileCode: '',
                    mobileViewCode: '',
                },
            },
        ],
    },
    {
        auth: [],
        author: '',
        code: 'scenegroup',
        description: '',
        engineCode: '',
        extension: [],
        helpLinkUrl: '',
        hook: '',
        icon: 'ding-stroke',
        name: '钉钉群聊',
        publishedTime: '',
        id: '',
        version: '0.0.1',
        status: 1,
        ui: [
            {
                createSchema: true,
                dataType: H3.Control.BizDataType.String,
                definition: '',
                design: {
                    code: scheduleDesign.default,
                    isDefault: true,
                    properties: [
                        {
                            key: 'SceneGroupSetting',
                            name: '钉群配置',
                            code: SceneGroupSetting.default,
                            required: true,
                            type: 31,
                        },
                        {
                            key: 'SceneGroupMappings',
                            name: '字段配置',
                            code: sceneGroupMappings.default,
                            required: true,
                            type: 31,
                        },
                    ],
                },
                runtime: {
                    pcCode: sceneGroupRuntime.default,
                    pcViewCode: '',
                    mobileCode: '',
                    mobileViewCode: '',
                },
            },
        ],
    },
];
